import React from "react";

const TableSkeleton = ({ rows, columns, columnWidths = [] }) => {
  return (
    <tbody className="animate-pulse divide-y divide-gray-200 bg-white">
      {Array(rows)
        .fill()
        .map((_, rowIndex) => (
          <tr key={rowIndex}>
            {Array(columns)
              .fill()
              .map((_, colIndex) => {
                const col = columnWidths[colIndex] || {};
                return (
                  <td
                    key={colIndex}
                    className={`px-4 py-2 ${col.align === "right" ? "text-right" : ""} ${col.tdWidth || ""}`}
                  >
                    <div
                      className={`h-3 bg-gray-300 rounded-md ${col.align === "right" ? "ml-auto" : ""} ${col.width || "w-14"}`}
                    />
                  </td>
                );
              })}
          </tr>
        ))}
    </tbody>
  );
};

export default TableSkeleton;
